module.exports = __webpack_public_path__ + "img/8a834e7.webp";